import { actionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';
import { actionTypes as headerActionTypes } from './GatewayDetails/Header/constants';
import { DISCONNECT_ASSET } from './GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/DisconnectAsset/constants';
import { VALIDATE_GATEWAY_ASSET } from './GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/MoveToAnotherGateway/constants';
import { GET_PARAMETER_BACKUP } from './GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/ParameterBackup/constants';
import { GET_GATEWAY_ASSETS_LIST, VALIDATE_SWITCH_GATEWAY_ASSET } from './GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/SwitchToAnotherGateway/constants';
import { actionTypes as disconnectActionTypes } from './GatewayDetails/ConnectedAssets/ConnectedAssetsEnvironmentSensors/DisconnectEnvironmentSensor/constants';
import { actionTypes as enableDisableActionTypes } from './GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/EnableDisableDrive/constants';
import { actionTypes as AssignActionTypes } from './SerialNumberEditor/constants';

const initialState = {
    gatewayList: [],
    myGateways: [],
    otherGateways: {
        emptyGateways: [],
        unknownGateways: null,
        unassignedGateways: []
    },
    error: null,
    loadingStatus: null,
    assignSerialNumber: {
        loadingStatus: null,
        isAssigned: false,
        error: null
    },
    disconnectAsset: {
        loadingStatus: null,
        error: null
    },
    disconnectEnvironmentSensor: {
        loadingStatus: null,
        error: null
    },
    validateGatewayAsset: {
        loadingStatus: null,
        error: null
    },
    validateSwitchGatewayAsset: {
        loadingStatus: null,
        error: null
    },
    getParameterBackup: {
        loadingStatus: null,
        error: null
    },
    gatewayAssetsList: {
        loadingStatus: null,
        error: null
    },
    getGatewayConnectedAssetsSettings: {
        loadingStatus: null,
        error: null
    },
    enableDisableDriveSettings: {
        loadingStatus: null,
        error: null
    },
    assignSerialNumberSettings: {
        loadingStatus: null,
        error: null
    },
    validateSerialNumberSettings: {
        loadingStatus: null,
        error: null
    },
    serialNumberEditorModal: {
        isModalOpen: false
    },
    selectedAssetDetails: null,
    selectedMenuItem: null,
    saveAssetDriveApplication: {
        loadingStatus: null,
        data: null,
        error: null
    },
    selectedGateway: null
};

const initialDriveApplicationsState = {
    loadingStatus: null,
    error: null,
    data: null
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialState;
        }
        case headerActionTypes.SELECT_MENU_ITEM: {
            return {
                ...state,
                selectedMenuItem: action.selectedMenuItem
            };
        }
        case actionTypes.GET_GATEWAY_LIST_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                const data = action.data;
                const myGateways = data?.myGateways || [];
                const emptyGateways = data?.otherGateways?.emptyGateways || [];
                const unknownGateways = data?.otherGateways?.unknownGateways || null;
                const unassignedGateways = data?.otherGateways?.unassignedGateways || [];
                const gatewayList = [
                    ...myGateways,
                    ...emptyGateways,
                    ...unassignedGateways
                ];
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    gatewayList,
                    myGateways,
                    otherGateways: {
                        emptyGateways,
                        unknownGateways,
                        unassignedGateways
                    },
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayList: [],
                    myGateways: [],
                    otherGateways: {
                        emptyGateways: [],
                        unknownGateways: null,
                        unassignedGateways: []
                    },
                    error: action.error
                };
            }
            break;
        case actionTypes.OPEN_SERIAL_NUMBER_EDITOR_MODAL:
            return {
                ...state,
                serialNumberEditorModal: {
                    ...state.serialNumberEditorModal,
                    isModalOpen: true
                }
            };
        case actionTypes.CLOSE_SERIAL_NUMBER_EDITOR_MODAL:
            return {
                ...state,
                serialNumberEditorModal: {
                    ...state.serialNumberEditorModal,
                    isModalOpen: false
                }
            };
        case actionTypes.ASSIGN_SERIAL_NUMBER_SETTINGS:
            return {
                ...state,
                assignSerialNumber: {
                    ...state.assignSerialNumber,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                    isAssigned: action.loadingStatus === apiCallStatus.SUCCESS ? action.data.isAssigned : false
                }
            };
        case DISCONNECT_ASSET:
            return {
                ...state,
                disconnectAsset: {
                    ...state.disconnectAsset,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                }
            };
        case VALIDATE_GATEWAY_ASSET:
            return {
                ...state,
                validateGatewayAsset: {
                    ...state.validateGatewayAsset,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                }
            };
        case GET_GATEWAY_ASSETS_LIST:
            return {
                ...state,
                gatewayAssetsList: {
                    ...state.gatewayAssetsList,
                    loadingStatus: action.loadingStatus,
                    error: action.error
                }
            };
        case VALIDATE_SWITCH_GATEWAY_ASSET:
            return {
                ...state,
                validateSwitchGatewayAsset: {
                    ...state.validateSwitchGatewayAsset,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                }
            };
        case GET_PARAMETER_BACKUP:
            return {
                ...state,
                parameterBackup: {
                    ...state.parameterBackup,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                }
            };
        case enableDisableActionTypes.ENABLE_DISABLE_DRIVE_REQUEST:
            return {
                ...state,
                enableDisableDriveSettings: {
                    ...state.enableDisableDriveSettings,
                    loadingStatus: action.loadingStatus,
                    error: action.error
                }
            };
        case AssignActionTypes.VALIDATE_SERIAL_NUMBER_SETTINGS:
            return {
                ...state,
                validateSerialNumberSettings: {
                    ...state.validateSerialNumberSettings,
                    loadingStatus: action.loadingStatus,
                    error: action.error
                }
            };
        case AssignActionTypes.ASSIGN_SERIAL_NUMBER_SETTINGS:
            return {
                ...state,
                assignSerialNumberSettings: {
                    ...state.assignSerialNumberSettings,
                    loadingStatus: action.loadingStatus,
                    error: action.error
                }
            };
        case disconnectActionTypes.DISCONNECT_ENVIRONMENT_SENSOR_SETTINGS:
            return {
                ...state,
                disconnectEnvironmentSensor: {
                    ...state.disconnectEnvironmentSensor,
                    loadingStatus: action.loadingStatus,
                    error: action.error,
                }
            };
        case actionTypes.GET_UPDATE_ASSET_DRIVE_APPLICATION_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    saveAssetDriveApplication: {
                        ...state.saveAssetDriveApplication,
                        loadingStatus: apiCallStatus.LOADING,
                        error: null
                    }
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    saveAssetDriveApplication: {
                        ...state.saveAssetDriveApplication,
                        loadingStatus: apiCallStatus.SUCCESS,
                        data: action.data,
                        error: null
                    }
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    saveAssetDriveApplication: {
                        ...state.saveAssetDriveApplication,
                        loadingStatus: apiCallStatus.ERROR,
                        data: null,
                        error: action.error
                    }
                };
            }
            break;
        case actionTypes.SET_SELECTED_GATEWAY:
            return {
                ...state,
                selectedGateway: action.selectedGateway
            };
        case actionTypes.SELECT_ASSET:
            return {
                ...state,
                selectedAssetDetails: action.selectedAssetDetails
            };
        default:
            return state;
    }
}

const initialGatewayTypeState = {
    gatewayType: [],
    error: null,
    loadingStatus: null
};

export function gatewayTypeReducer(state = initialGatewayTypeState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialGatewayTypeState;
        }
        case actionTypes.GET_GATEWAY_TYPE_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    gatewayType: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    gatewayType: [],
                    error: action.error
                };
            }
            break;
        default:
            return state;
    }
}

export function driveApplicationsReducer(state = initialDriveApplicationsState, action) {
    switch (action.type) {
        case actionTypes.CLEAR_STORE: {
            return initialDriveApplicationsState;
        }
        case actionTypes.CLEAR_DRIVE_APPLICATIONS: {
            return initialDriveApplicationsState;
        }
        case actionTypes.GET_DRIVE_APPLICATIONS_SETTINGS:
            if (action.loadingStatus === apiCallStatus.LOADING) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.LOADING,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.SUCCESS) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.SUCCESS,
                    data: action.data,
                    error: null
                };
            } else if (action.loadingStatus === apiCallStatus.ERROR) {
                return {
                    ...state,
                    loadingStatus: apiCallStatus.ERROR,
                    data: null,
                    error: action.error
                };
            }
            return state;
        default:
            return state;
    }
}
